/**
 * Sets the Cognito store in session storage.
 * 
 * @param store any
 */
const setCognitoStore = (store: any) => {
  const { accessToken, idToken, refreshToken } = JSON.parse(store.body);

  sessionStorage.setItem('cognitoIdToken', idToken);
  sessionStorage.setItem('cognitoAccessToken', accessToken);
  if ( refreshToken )
  sessionStorage.setItem('cognitoRefreshToken', refreshToken);
};

/**
 * Gets the 
 * 
 * @returns any
 */
const getCognitoStore = () => { 
  const IdToken = sessionStorage.getItem('cognitoIdToken');
  const AccessToken = sessionStorage.getItem('cognitoAccessToken');
  const RefreshToken = sessionStorage.getItem('cognitoRefreshToken');

  return { IdToken, AccessToken, RefreshToken };
}

export { setCognitoStore, getCognitoStore };